import { render, staticRenderFns } from "./userIntegralList.vue?vue&type=template&id=625e9304&scoped=true"
import script from "./userIntegralList.vue?vue&type=script&lang=js"
export * from "./userIntegralList.vue?vue&type=script&lang=js"
import style0 from "./userIntegralList.vue?vue&type=style&index=0&id=625e9304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e9304",
  null
  
)

export default component.exports